module.exports = __webpack_public_path__ + "img/img_nav_money-w.c5ee537d.svg";